export function getBufferFromBN(r,endian,length){try{return r.toBuffer(endian,length);}catch(error){return r.toArrayLike(Buffer,endian,length);}}